import React, { Component } from "react";
import { connect } from 'react-redux';
import { Button, Card, Badge } from 'react-bootstrap';
import moment from 'moment';

import "./AnnouncementsPage.css";
import { ContainerWrapper, Content, Row, Col } from '../../../components/GridComponent/AdminLte.js';
import PageLoading from "../../PageLoading";
import Wrapper from "../../../components/Template/Wrapper";
import NoticeBody from "../../../components/Broadcasts/Queue/NoticeBody";
import { fetchBroadcast, clearBroadcastInstance, fetchBroadcastFeed, downloadBroadcastPdf } from '../../../store/actions/broadcasts/broadcastActions';

/**
 * Announcement archive page (Dashboard -> All Announcements -> card). Reads one item from the
 * announcements engine (GET /broadcasts/{id}); a 404 means the item is not visible to this
 * user (outside the audience, inactive, or expired for more than 12 months).
 *
 * A per-person form (SPEC 23.5) also lists "Your documents" from `my_documents`
 * [{id, status, raised_at, signed_at, hr_values, pdf_url}]: status, dates, and Download for a
 * signed one (pdf_url is only there once signed; fetched through the authenticated export call).
 */

const DOC_STATUS = { pending: "Pending", signed: "Signed" };

const localDate = (utc) => (utc ? moment.utc(utc).local().format("YYYY-MM-DD") : "");

class AnnouncementsPage extends Component {

  componentDidMount() {
    this.props.clearBroadcastInstance();
    if (this.props.params.id !== undefined) {
      // view=audience: a manager (HR / head) would otherwise get the manage shape (media array, no cta)
      // and never see the media or the CTA on an archive page.
      this.props.fetchBroadcast(this.props.params.id, "audience");
    }
    // "Latest Announcements" side list.
    if (!this.props.feed.isLoaded) {
      this.props.fetchBroadcastFeed({ page: 1, per_page: 6 });
    }
  }

  openCta = (url) => window.open(url, "_blank", "noopener");

  renderDocuments = (instance) => (
    <div className="announcement-documents">
      <h5>Your documents</h5>
      {instance.my_documents.length === 0 ? <p>No documents</p> : (
        <table className="table table-sm">
          <thead>
            <tr><th>Raised</th><th>Status</th><th>Signed</th><th></th></tr>
          </thead>
          <tbody>
            {instance.my_documents.map((doc) => (
              <tr key={doc.id}>
                <td>{doc.raised_at}</td>
                <td>{DOC_STATUS[doc.status] || doc.status}</td>
                <td>{doc.signed_at || ""}</td>
                <td>
                  {doc.status === "signed" && doc.pdf_url ? (
                    <Button size="sm" variant="outline-primary"
                      onClick={() => this.props.downloadBroadcastPdf(doc.pdf_url, "document-" + doc.id + ".pdf")}>Download</Button>
                  ) : null}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );

  renderItem = (instance) => {
    return (
      <div className="announcement-content-page">
        <div>
          <div className="page-content-title">{instance.title}</div>
          <div className="page-content-info">
            Posted: {localDate(instance.starts_at)}<br />
            <Badge className="tag-badge">{instance.category}</Badge>
          </div>
          {instance.headline ? <div className="page-content-headline">{instance.headline}</div> : null}
          {instance.thumbnail_url ? <img src={instance.thumbnail_url} className="page-img" alt="" /> : null}
          <div className="page-content">
            <NoticeBody item={instance} />
          </div>
          {instance.cta && instance.cta.url ? (
            <Button variant="outline-primary" onClick={() => this.openCta(instance.cta.url)}>{instance.cta.label}</Button>
          ) : null}
          {Array.isArray(instance.my_documents) ? this.renderDocuments(instance) : null}
        </div>
      </div>
    );
  }

  render() {
    const { instance, instanceError, feed } = this.props;

    if (!instance && !instanceError) {
      return <PageLoading />;
    }

    return <Wrapper {...this.props} >
      <ContainerWrapper className="Announcement Wrapper">
        <Row>
          <Col size="9">
            <Content col="12" title={null}>
              {instance
                ? this.renderItem(instance)
                : <h5>This announcement is not available to you</h5>
              }
            </Content>
          </Col>

          <Col size="3">
            <div className="card-header">
              <h3 align="Left" className="card-title">Latest Announcements</h3>
            </div>
            {feed.isLoaded ? (
              <Row>
                {feed.list.slice(0, 4).map((announcement) => {
                  const external = announcement.on_link == 1;
                  const href = external ? announcement.link : global.links.announcement_page + announcement.id;
                  return (
                    <Col size={11} key={announcement.id} className="announcement-list-content card-content">
                      <a href={href} target={external ? "_blank" : "_self"} rel={external ? "noopener noreferrer" : undefined}>
                        <Card className="announcement-list-card card-pad-bottom">
                          <Card.Body className="small-card-body ">
                            <Card.Text className="black-card-text-bigger"> {announcement.title}</Card.Text>
                            <Card.Text> {localDate(announcement.starts_at)} <br /> <Badge className="tag-badge">{announcement.category}</Badge></Card.Text>
                          </Card.Body>
                        </Card>
                      </a>
                    </Col>
                  );
                })}
              </Row>
            ) : null}
          </Col>
        </Row>
      </ContainerWrapper>
    </Wrapper>;
  }
}

const mapStateToProps = (state) => {
  return {
    constant        : state.constant,
    instance        : state.broadcasts.instance,
    instanceError   : state.broadcasts.instanceError,
    feed            : state.broadcasts.feed,
    user            : state.user,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    fetchBroadcast          : ( id, view ) => dispatch( fetchBroadcast( id, view ) ),
    clearBroadcastInstance  : () => dispatch( clearBroadcastInstance() ),
    fetchBroadcastFeed      : ( params ) => dispatch( fetchBroadcastFeed( params ) ),
    downloadBroadcastPdf    : ( url, name ) => dispatch( downloadBroadcastPdf( url, name ) ),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(AnnouncementsPage);
